import { useWorkspaceStanding } from '@/features/workspaces';

/**
 * Whether this person may read this workspace's spend figures.
 *
 * The same rule the sidebar uses to decide whether to draw the Usage entry at
 * all: the workspace's own owner, or an organisation administrator (spec 075).
 * The service decides for real; this only decides whether to ask.
 *
 * It is worth asking that question before the request rather than after. A
 * board is opened by every member of a workspace, and a read that is certain to
 * come back 403 costs a round trip on every one of those loads to learn what
 * the identity already in cache could have said. Both reads here are cached
 * already — the aggregate by the page, identity by the session — so the gate
 * itself costs nothing.
 *
 * False while either read is in flight, so nothing is asked for on a guess.
 */
export function useMayReadUsage(workspaceId: string): boolean {
  // One rule with the sidebar's, now from the workspace's own `access` (spec 188).
  return useWorkspaceStanding(workspaceId).mayReadUsage;
}
